import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { socialApi } from '../api/social.api'
import type { PrivacyLevelValue } from '../types'

export const PRIVACY_KEY = ['social', 'privacy'] as const

export function usePrivacySettings() {
  return useQuery({
    queryKey: PRIVACY_KEY,
    queryFn: () => socialApi.fetchPrivacy().then((r) => r.data.data),
    staleTime: 60_000,
  })
}

export function useUpdatePrivacy() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (level: PrivacyLevelValue) =>
      socialApi.updatePrivacy(level).then((r) => r.data.data),
    // Le niveau conditionne aussi la présence dans les classements.
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: PRIVACY_KEY })
      void queryClient.invalidateQueries({ queryKey: ['social', 'leaderboard'] })
    },
  })
}
